import React from 'react';
interface StarRatingProps {
  count?: number;
  size?: number;
  className?: string;
  label?: string;
}

/**
 * Inline-SVG star row. No icon library, no extra bytes.
 */
export function StarRating({
  count = 5,
  size = 16,
  className = '',
  label = 'Calificación 5 de 5 estrellas'
}: StarRatingProps) {
  return <span className={`inline-flex items-center gap-0.5 ${className}`} role="img" aria-label={label} data-id="element-258" data-mp="3p4kevw6aycxk">
      {Array.from({
      length: count
    }).map((_, index) => <svg key={index} width={size} height={size} viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" focusable="false" data-id="element-259" data-mp="1y1nkg2f9od6" data-mpi={index}>
          <path d="M10 1.6l2.47 5.01 5.53.8-4 3.9.94 5.51L10 14.22l-4.94 2.6.94-5.51-4-3.9 5.53-.8L10 1.6z" data-id="element-260" data-mp="bvxusws8nz60" />
        </svg>)}
    </span>;
}